import React from 'react';
import NameListRow from './NameListRow';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../elsterEmployeeTable.css';
const NAME_LIST_HEADINGS_WITH_HALF_YEAR = ['employee_name_number', 'half_year_required', 'bda_check_if_yes', 'fulltime', 'digital_record', '', '', ''];
const NAME_LIST_HEADINGS_WITHOUT_HALF_YEAR = ['employee_name_number', 'bda_check_if_yes', 'fulltime', 'digital_record', '', '', ''];
const NameList = _ref => {
  let {
    data,
    setData,
    selectedProject,
    emptyNameLists,
    removeEmptyRow,
    elster
  } = _ref;
  const {
    t
  } = useTranslation();
  const showHalfYearColumn = (elster === null || elster === void 0 ? void 0 : elster.elster_year_for_staff_cost) != null;
  const elsterYearForStaffCost = elster === null || elster === void 0 ? void 0 : elster.elster_year_for_staff_cost;
  const tableHeadings = showHalfYearColumn ? NAME_LIST_HEADINGS_WITH_HALF_YEAR : NAME_LIST_HEADINGS_WITHOUT_HALF_YEAR;
  const tableHeadingRow = tableHeadings.map((heading, i) => {
    return /*#__PURE__*/React.createElement("th", {
      key: 'th' + i
    }, t(heading));
  });
  const tableRows = data.map(currentData => {
    return /*#__PURE__*/React.createElement(NameListRow, {
      rowData: currentData,
      key: currentData.id,
      data: data,
      setData: setData,
      selectedProject: selectedProject,
      showHalfYearColumn: showHalfYearColumn,
      elsterYearForStaffCost: elsterYearForStaffCost
    });
  });
  const emptyRows = emptyNameLists.map(emptyNameList => {
    return /*#__PURE__*/React.createElement(NameListRow, {
      key: 'createRowNameList' + emptyNameList.emptyRowId,
      emptyRowId: emptyNameList.emptyRowId,
      data: data,
      setData: setData,
      selectedProject: selectedProject,
      removeEmptyRow: removeEmptyRow,
      rowData: emptyNameList,
      showHalfYearColumn: showHalfYearColumn,
      elsterYearForStaffCost: elsterYearForStaffCost
    });
  });
  return /*#__PURE__*/React.createElement(Table, {
    responsive: "md",
    className: "elster-employee-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, tableHeadingRow)), /*#__PURE__*/React.createElement("tbody", null, tableRows, emptyRows));
};
export default NameList;